import React from "react";

export default function Breadcrumb({ background, title, children }) {
    return (
        <section
            className="banner"
            style={{ backgroundImage: `url('${background}')` }}
        >
            <h1>{title}</h1>
            <ul className="breadcrumb">
                <li>
                    {" "}
                    <a href={(currentLang === "tr" ? "" : currentLang) + "/"}>
                        ANASAYFA
                    </a>{" "}
                </li>
                {children}
            </ul>
        </section>
    );
}
